/**
 * Configuração pública do app que os módulos precisam ler (injetada pelo apps/os no início).
 * Ex.: o endereço do Jitsi self-hosted para a sala de vídeo embutida (VITE_MEET_URL).
 */
export interface AppConfig {
  /** Origem do Jitsi (https://meet.vixio.com.br), sem barra no fim. Vazio: sem sala embutida. */
  meetUrl: string;
}

let current: AppConfig = { meetUrl: "" };

export function configureApp(c: Partial<AppConfig>): void {
  current = { ...current, ...c, meetUrl: (c.meetUrl ?? current.meetUrl).trim().replace(/\/+$/, "") };
}

export function getAppConfig(): AppConfig {
  return current;
}
